import React, { useState, useEffect } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(6),
    },
  },
  textField: {
    margin: theme.spacing(1),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },
  },
  submitButton: {
    margin: theme.spacing(3, 0),
  },
  tableContainer: {
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.1)',
    borderRadius: '12px',
    overflow: 'hidden',
    marginTop: '32px',
    backgroundColor: '#f9f9f9'
  },
  tableHeader: {
    backgroundColor: '#01b5e2',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '1rem'
  },
  tableRow: {
    '&:hover': {
      backgroundColor: '#e5f7fb',
    },
  },
  tableCell: {
    padding: theme.spacing(1.5, 2),
    fontSize: '0.9rem'
  },
  actionButton: {
    color: '#01b5e2',
    borderColor: '#01b5e2',
    '&:hover': {
      backgroundColor: '#01b5e2',
      color: 'white',
    }
  }
}));

const ModerationMessages = () => {
  const classes = useStyles();
 
  return (
    <div>
    </div>
  );
};

export default ModerationMessages;
